import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
    TimelineTrainings: false,
    getTimelineTrainingsLoading: false,
    createTimelineTrainingLoading: false,
};

const TimelineTrainingSlice = createSlice({
    name: "TimelineTraining",
    initialState,
    reducers: {
        getTimelineTrainings(state, { payload }) {
            message.info("Consultando programaciones...");
        },
        setTimelineTrainings(state, { payload }) {
            state.TimelineTrainings = payload;
        },
        createTimelineTraining(state, { payload }) {
            state.createTimelineTrainingLoading = true;
        },
        editTimelineTraining(state, { payload }) {
            state.createTimelineTrainingLoading = true;
        },
        setGetTimelineTrainingsLoading(state, { payload }) {
            state.getTimelineTrainingsLoading = payload;
        },
        setCreateTimelineTrainingLoading(state, { payload }) {
            state.createTimelineTrainingLoading = payload;
        },
    },
});

const TimelineTrainingActions = TimelineTrainingSlice.actions;
const TimelineTrainingReducer = TimelineTrainingSlice.reducer;

export { TimelineTrainingActions, TimelineTrainingReducer };
